import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import PublicFooter from '@/components/PublicFooter';

/**
 * Shared visual shell for all legal/policy pages.
 * Keeps typography consistent and provides a "back" link to /.
 */
export default function LegalLayout({ title, version = 'v1.0', updated = '31 May 2026', children, testId }) {
  return (
    <div className="min-h-screen bg-white" data-testid={testId || 'legal-page'}>
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-slate-900 hover:text-rose-700" data-testid="legal-back-home">
            <ShieldCheck className="h-5 w-5 text-rose-600" />
            <span>BeautyMateUK</span>
          </Link>
          <Link to="/" className="flex items-center gap-1 text-xs text-slate-500 hover:text-slate-900">
            <ArrowLeft className="h-3 w-3" /> Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-slate-900 mb-2" data-testid="legal-title">{title}</h1>
          <p className="text-xs text-slate-500">Version {version} · Last updated {updated}</p>
        </div>
        <article className="prose prose-slate max-w-none text-slate-700 leading-relaxed [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-slate-900 [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_li]:my-1">
          {children}
        </article>
      </main>
      <PublicFooter variant="light" />
    </div>
  );
}
